import { DepartmentEntry } from '../types';

export const Departments: DepartmentEntry[] = [
  {
    id: 'finance',
    title: 'Principal / Principal Asset Management / Finance',
    bu_abbr: 'PGAM',
  },
  {
    id: 'technology',
    title: 'Principal / Principal Asset Management / Technology',
    bu_abbr: 'PGAM',
  },
  {
    id: 'us-and-europe-client-group',
    title:
      'Principal / Principal Asset Management / US and Europe Client Group',
    bu_abbr: 'PGAM',
  },
  {
    id: 'global-operations-and-services',
    title:
      'Principal / Principal Asset Management / Global Operations and Services',
    bu_abbr: 'PGAM',
  },
  {
    id: 'multi-asset',
    title: 'Principal / Principal Asset Management / Multi Asset',
    bu_abbr: 'PGAM',
  },
  {
    id: 'private-markets',
    title: 'Principal / Principal Asset Management / Private Markets',
    bu_abbr: 'PGAM',
  },
  {
    id: 'public-markets',
    title: 'Principal / Principal Asset Management / Public Markets',
    bu_abbr: 'PGAM',
  },
  {
    id: 'retirement-strategy-and-solutions',
    title:
      'Principal / Principal Asset Management / Retirement Strategy and Solutions',
    bu_abbr: 'PGAM',
  },
  {
    id: 'strategy-marketing-and-insights',
    title:
      'Principal / Principal Asset Management / Strategy, Marketing and Insights',
    bu_abbr: 'PGAM',
  },
  {
    id: 'principal-international-latin-america',
    title:
      'Principal / Principal International / Principal International Latin America',
    bu_abbr: 'PI',
  },
  {
    id: 'principal-international-asia',
    title: 'Principal / Principal International / Principal International Asia',
    bu_abbr: 'PI',
  },
  {
    id: 'pi-corporate',
    title: 'Principal / Principal International / PI Corporate (U.S.)',
    bu_abbr: 'PI',
  },
  {
    id: 'pi-india',
    title: 'Principal / Principal International / PI India',
    bu_abbr: 'PI',
  },
  {
    id: 'income-solutions',
    title: 'Principal / Retirement and Income Solutions / Income Solutions',
    bu_abbr: 'RIS',
  },
  {
    id: 'individual-solutions',
    title: 'Principal / Retirement and Income Solutions / Individual Solutions',
    bu_abbr: 'RIS',
  },
  {
    id: 'shared-services',
    title: 'Principal / Retirement and Income Solutions / Shared Services',
    bu_abbr: 'RIS',
  },
  {
    id: 'workplace-savings-and-retirement-solutions',
    title:
      'Principal / Retirement and Income Solutions / Workplace Savings and Retirement Solutions',
    bu_abbr: 'RIS',
  },
  {
    id: 'business-continuity',
    title: 'Principal / Service Center Business Units / Business Continuity',
    bu_abbr: 'SCBU',
  },
  {
    id: 'corporate-customer-service',
    title:
      'Principal / Service Center Business Units / Corporate Customer Service',
    bu_abbr: 'SCBU',
  },
  {
    id: 'elevate-by-principal',
    title: 'Principal / Service Center Business Units / Elevate By Principal',
    bu_abbr: 'SCBU',
  },
  {
    id: 'enterprise-business-solutions',
    title:
      'Principal / Service Center Business Units / Enterprise Business Solutions',
    bu_abbr: 'SCBU',
  },
  {
    id: 'enterprise-data-and-analytics',
    title:
      'Principal / Service Center Business Units / Enterprise Data and Analytics',
    bu_abbr: 'SCBU',
  },
  {
    id: 'enterprise-documents',
    title: 'Principal / Service Center Business Units / Enterprise Documents',
    bu_abbr: 'SCBU',
  },
  {
    id: 'enterprise-strategy-and-innovation',
    title:
      'Principal / Service Center Business Units / Enterprise Strategy and Innovation',
    bu_abbr: 'SCBU',
  },
  {
    id: 'enterprise-worksite-services',
    title:
      'Principal / Service Center Business Units / Enterprise Worksite Services',
    bu_abbr: 'SCBU',
  },
  {
    id: 'global-brand-and-experience',
    title:
      'Principal / Service Center Business Units / Global Brand and Experience',
    bu_abbr: 'SCBU',
  },
  {
    id: 'global-financial-resources',
    title:
      'Principal / Service Center Business Units / Global Financial Resources',
    bu_abbr: 'SCBU',
  },
  {
    id: 'global-risk',
    title: 'Principal / Service Center Business Units / Global Risk',
    bu_abbr: 'SCBU',
  },
  {
    id: 'global-sourcing',
    title: 'Principal / Service Center Business Units / Global Sourcing',
    bu_abbr: 'SCBU',
  },
  {
    id: 'government-relations',
    title: 'Principal / Service Center Business Units / Government Relations',
    bu_abbr: 'SCBU',
  },
  {
    id: 'human-resources',
    title: 'Principal / Service Center Business Units / Human Resources',
    bu_abbr: 'SCBU',
  },
  {
    id: 'information-services',
    title: 'Principal / Service Center Business Units / Information Services',
    bu_abbr: 'SCBU',
  },
  {
    id: 'law',
    title: 'Principal / Service Center Business Units / Law',
    bu_abbr: 'SCBU',
  },
  {
    id: 'principal-global-services',
    title:
      'Principal / Service Center Business Units / Principal Global Services',
    bu_abbr: 'SCBU',
  },
  {
    id: 'business-owner-solutions',
    title: 'Principal / Benefits and Protection / Business Owner Solutions',
    bu_abbr: 'BP',
  },
  {
    id: 'bp-claims',
    title: 'Principal / Benefits and Protection / BP Claims',
    bu_abbr: 'BP',
  },
  {
    id: 'bp-distribution',
    title: 'Principal / Benefits and Protection / BP Distribution',
    bu_abbr: 'BP',
  },
  {
    id: 'bp-operations',
    title: 'Principal / Benefits and Protection / BP Operations',
    bu_abbr: 'BP',
  },
  {
    id: 'bp-shared-services',
    title: 'Principal / Benefits and Protection / BP Shared Services',
    bu_abbr: 'BP',
  },

  {
    id: 'workplace-benefits',
    title: 'Principal / Benefits and Protection / Workplace Benefits',
    bu_abbr: 'BP',
  },
];
